import { lazy } from '../../shared/deployment';

export const EvaluationList = lazy(() => import('./EvaluationList'));
export const EvaluationSingle = lazy(() => import('../../modules/evaluations/ui/EvaluationSingle'));
